<template>
  <div v-if="isVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-lg p-6 max-h-[90vh] overflow-y-auto">
      <h2 class="text-lg font-bold mb-4">{{ isEdit ? 'Редактирование группы' : 'Создать группу' }}</h2>
      <form @submit.prevent="submitForm">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Название</label>
          <input
            v-model="formData.name"
            type="text"
            required
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Например: Склады"
          />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Тип модуля (для иконки)</label>
          <select
            v-model="formData.module_type_id"
            required
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="" disabled>Выберите тип</option>
            <option v-for="type in moduleTypes" :key="type.id" :value="type.id">
              {{ type.name }}
            </option>
          </select>
          <p class="text-xs text-neutral-500 mt-1">Определяет иконку группы в навигации. Не ограничивает привязку модулей.</p>
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-2">Модули в группе</label>
          <div v-if="allModules.length === 0" class="text-sm text-neutral-500 py-2">
            Нет доступных модулей
          </div>
          <div v-else class="space-y-2 max-h-48 overflow-y-auto">
            <label
              v-for="m in allModules"
              :key="m.id"
              class="flex items-center gap-2 cursor-pointer hover:bg-neutral-50 p-2 rounded"
            >
              <input
                v-model="formData.module_ids"
                type="checkbox"
                :value="m.id"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span>{{ m.name }}</span>
              <span class="text-xs text-neutral-400">({{ m.module_type?.name || '' }})</span>
            </label>
          </div>
        </div>
        <div class="flex justify-end gap-2">
          <button
            type="button"
            @click="closeModal"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
          >
            Отмена
          </button>
          <button
            type="submit"
            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
          >
            Сохранить
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modulesForAssignment: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['saved'],
  data() {
    return {
      isVisible: false,
      editingGroup: null,
      moduleTypes: [],
      formData: {
        name: '',
        module_type_id: '',
        module_ids: [],
      },
    }
  },
  computed: {
    isEdit() {
      return !!this.editingGroup
    },
    allModules() {
      return this.modulesForAssignment || []
    },
  },
  methods: {
    fetchModuleTypes() {
      axios
        .post('/api/moduleType/getModuleTypes')
        .then((res) => {
          this.moduleTypes = res.data?.data || []
        })
        .catch(() => {
          this.moduleTypes = []
        })
    },
    show(group = null) {
      this.fetchModuleTypes()
      this.editingGroup = group
      if (group) {
        this.formData = {
          name: group.name,
          module_type_id: group.module_type_id ?? group.module_type?.id ?? '',
          module_ids: (group.modules || []).map((m) => m.id),
        }
      } else {
        this.formData = {
          name: '',
          module_type_id: '',
          module_ids: [],
        }
      }
      this.isVisible = true
    },
    closeModal() {
      this.isVisible = false
      this.editingGroup = null
    },
    submitForm() {
      const payload = {
        name: this.formData.name,
        module_type_id: parseInt(this.formData.module_type_id, 10),
        module_ids: this.formData.module_ids,
      }
      if (this.editingGroup?.id) {
        payload.id = this.editingGroup.id
      }
      axios
        .post('/api/moduleGroup/createOrUpdateModuleGroup', payload)
        .then(() => {
          this.$emit('saved')
          this.closeModal()
        })
        .catch((err) => console.error(err))
    },
  },
}
</script>
